import cashResetApi from "../../api/cash/cashResetApi";

/**
 * 🧹 Limpieza de REGISTROS de caja (aperturas/sesiones, cortes X/Z,
 * movimientos) — panel solo-SUPPORT. No confundir con el flujo de cierre
 * de caja en sí; esto llama al backend y elimina datos reales.
 */
const CashRegistryResetService = {

    /**
     * 📊 Resumen actual de registros de caja
     * GET /api/cash/admin/reset/summary
     */
    getSummary: async () => {

        const response = await cashResetApi.fetchCustom("/summary");
        return response.data;

    },

    /**
     * 🧹 Ejecutar la limpieza (elimina aperturas/sesiones, cortes X/Z y
     * movimientos; NO toca las ventas, solo suelta su referencia a la
     * sesión eliminada)
     * POST /api/cash/admin/reset
     */
    execute: async () => {

        const response = await cashResetApi.addWithoutData("");
        return response.data;

    },

};

export default CashRegistryResetService;
